module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/images/background-conscription.4badd20d.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/images/background-conscription.jpg
// module id = 2817
// module chunks = 11